import * as React from 'react';
import Quote from "@system/config/quote";
import { useQuoteStore } from 'src/hooks/quote';
import System from 'src/helper/system';
import { useState } from "react";

export function OpenQuoteTableHeader() {
    const [{ openQuoteList, openQuoteCount }, { }, { }] = useQuoteStore();
    const isDisabled = (!(openQuoteList && openQuoteCount > 0));
    const [loader, setLoader] = useState(false);


    return (
        <>
            <div className="additional-word-wrap align-items-center border-0">
                <div className="ps5 d-flex align-items-center quote-tabs-links mb-0">
                    <p className="ps5 text-black-stone mb-0">My Open Quotes</p>
                    <a href={Quote.getQuoteListingRouteURL()} className='ms-1'>My Submitted Quotes</a>
                </div>
                <div className='text-end px-3 pt-4 quote-tabs-content'>
                    <button className={`bs5 btn btn-secondary w145 ${isDisabled ? 'disabled' : ''}`} data-toggle="modal" data-target="#clearquote-modal" disabled={isDisabled || loader}
                        onClick={() => {
                            System.popup('ClearQuotePopup')
                        }}>CLEAR Quote</button>
                    <button className={`bs5 btn btn-primary w145 ms-2 ${isDisabled ? 'disabled' : ''}`} disabled={isDisabled || loader} onClick={() => {
                      setLoader(true);
                      window.location.href = Quote.getQuoteHeaderDetailRouteURL()
                    }}>{loader ? <i className="fa fa-spinner fa-spin" />: 'CONTINUE'}</button>
                </div>
            </div>
        </>
    );

}
